import React, { useState, useEffect } from 'react';
import { getAppVersion } from '../../api/versionService';
import './AppVersion.css';

const AppVersion = () => {
  const [version, setVersion] = useState('Cargando...');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const appVersion = await getAppVersion();
        setVersion(appVersion);
      } catch (error) {
        setVersion('v1.0.0-dev');
      } finally {
        setLoading(false);
      }
    };

    fetchVersion();
  }, []);


  if (loading) {
    return <span className="app-version loading">Cargando versión...</span>;
  }

  return (
    <span className="app-version">Ver. {version}</span>
  );
};

export default AppVersion;
